import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import fragments from './fragments';
import update from 'immutability-helper';


const createFlowMutation = gql`
mutation createFlow($projectId: ID!, $flowName: String!, $flowLocation: String!) {
  createFlow(projectId: $projectId, flowName: $flowName, flowLocation: $flowLocation) {
    ...flowFields
  }
}
${fragments.flowFields}`;

const createFlowMutationHoc = graphql(createFlowMutation, {
    props: ({mutate}) => ({
        createFlow: (projectId, flowName, flowLocation) => mutate({
            variables: {projectId, flowName, flowLocation},
            updateQueries: {
                project: (prev, {mutationResult}) => {
                    const newFlow = mutationResult.data.createFlow;
                    return update(prev, {
                        project: {
                            flows: {
                                $push: [newFlow]
                            }
                        }
                    });
                }
            }
        })
    })
});

const updateFlowMutation = gql`
mutation updateFlow($flowId: ID!, $flowName: String!, $flowLocation: String!) {
  updateFlow(flowId: $flowId, flowName: $flowName, flowLocation: $flowLocation) {
    ...flowFields
  }
}
${fragments.flowFields}`;

const updateFlowMutationHoc = graphql(updateFlowMutation, {
    props: ({mutate}) => ({
        updateFlow: (flowId, flowName, flowLocation) => mutate({
            variables: {flowId, flowName, flowLocation},
            updateQueries: {
                project: (prev, {mutationResult}) => {
                    const index = prev.project.flows.findIndex(flow => flow.id === flowId);
                    const updatedFlow = mutationResult.data.updateFlow;
                    return update(prev, {
                        project: {
                            flows: {
                                [index]: {
                                    name: {
                                        $set: updatedFlow.name
                                    },
                                    location: {
                                        $set: updatedFlow.location
                                    }
                                }
                            }
                        }
                    });
                }
            }
        })
    })
});

const deleteFlowMutation = gql`
mutation deleteFlow($flowId: ID!) {
  deleteFlow(flowId: $flowId) {
    ...flowFields
  }
}
${fragments.flowFields}`;

const deleteFlowMutationHoc = graphql(deleteFlowMutation, {
    props: ({mutate}) => ({
        deleteFlow: (flowId) => mutate({
            variables: {flowId},
            updateQueries: {
                project: (prev) => {
                    let index = prev.project.flows.findIndex(flow => flow.id === flowId);
                    return update(prev, {
                        project: {
                            flows: {
                                $splice: [[index, 1]]
                            }
                        }
                    });
                }
            }
        })
    })
});

const createNullStateMutation = gql`
mutation createNullState($projectId: ID!, $stateLocation: String!) {
  createNullState(projectId: $projectId, stateLocation: $stateLocation) {
    ...stateFields
  }
}
${fragments.stateFields}`;

const createNullStateMutationHoc = graphql(createNullStateMutation, {
    props: ({mutate}) => ({
        createNullState: (projectId, stateLocation) => mutate({
            variables: {projectId, stateLocation},
            updateQueries: {
                project: (prev, {mutationResult}) => {
                    const newState = mutationResult.data.createNullState;
                    return update(prev, {
                        project: {
                            states: {
                                $push: [newState]
                            }
                        }
                    });
                }
            }
        })
    })
});

const createFromAnyStateMutation = gql`
mutation createFromAnyState($flowId: ID!, $stateLocation: String!) {
  createFromAnyState(flowId: $flowId, stateLocation: $stateLocation) {
    ...stateFields
  }
}
${fragments.stateFields}`;

const createFromAnyStateMutationHoc = graphql(createFromAnyStateMutation, {
    props: ({mutate}) => ({
        createFromAnyState: (flowId, stateLocation) => mutate({
            variables: {flowId, stateLocation},
            updateQueries: {
                project: (prev, {mutationResult}) => {
                    const newState = mutationResult.data.createFromAnyState;
                    return update(prev, {
                        project: {
                            states: {
                                $push: [newState]
                            }
                        }
                    });
                }
            }
        })
    })
});

const createStateMutation = gql`
mutation createState($flowId: ID!, $stateName: String!, $stateLocation: String!) {
  createState(flowId: $flowId, stateName: $stateName, stateLocation: $stateLocation) {
    ...stateFields
  }
}
${fragments.stateFields}`;

const createStateMutationHoc = graphql(createStateMutation, {
    props: ({mutate}) => ({
        createState: (flowId, stateName, stateLocation) => mutate({
            variables: {flowId, stateName, stateLocation},
            updateQueries: {
                project: (prev, {mutationResult}) => {
                    const newState = mutationResult.data.createState;
                    return update(prev, {
                        project: {
                            states: {
                                $push: [newState]
                            }
                        }
                    });
                }
            }
        })
    })
});

const updateStateMutation = gql`
mutation updateState($stateId: ID!, $stateName: String!, $stateLocation: String!) {
  updateState(stateId: $stateId, stateName: $stateName, stateLocation: $stateLocation) {
    ...stateFields
  }
}
${fragments.stateFields}`;

const updateStateMutationHoc = graphql(updateStateMutation, {
    props: ({mutate}) => ({
        updateState: (stateId, stateName, stateLocation) => mutate({
            variables: {stateId, stateName, stateLocation},
            updateQueries: {
                project: (prev, {mutationResult}) => {
                    let index = prev.project.states.findIndex(state => state.id === stateId);
                    const updatedState = mutationResult.data.updateState;
                    return update(prev, {
                        project: {
                            states: {
                                [index]: {
                                    name: {
                                        $set: updatedState.name
                                    },
                                    location: {
                                        $set: updatedState.location
                                    }
                                }
                            }
                        }
                    });
                }
            }
        })
    })
});

const deleteStateMutation = gql`
mutation deleteState($stateId: ID!) {
  deleteState(stateId: $stateId) {
    ...stateFields
  }
}
${fragments.stateFields}`;

const deleteStateMutationHoc = graphql(deleteStateMutation, {
    props: ({mutate}) => ({
        deleteState: (stateId) => mutate({
            variables: {stateId},
            updateQueries: {
                project: (prev) => {
                    let index = prev.project.states.findIndex(state => state.id === stateId);
                    return update(prev, {
                        project: {
                            states: {
                                $splice: [[index, 1]]
                            }
                        }
                    });
                }
            }
        })
    })
});

const createTransitionMutation = gql`
mutation createTransition($projectId: ID!, $transitionInput: TransitionCreateInput!) {
  createTransition(projectId: $projectId, transitionInput: $transitionInput) {
    ...transitionFields
  }
}
${fragments.transitionFields}`;

const createTransitionMutationHoc = graphql(createTransitionMutation, {
    props: ({mutate}) => ({
        createTransition: (projectId, transitionInput) => mutate({
            variables: {projectId, transitionInput},
            updateQueries: {
                project: (prev, {mutationResult}) => {
                    if (mutationResult.errors) {
                        return prev;
                    }
                    const newTransition = mutationResult.data.createTransition;
                    return update(prev, {
                        project: {
                            transitions: {
                                $push: [newTransition]
                            }
                        }
                    });
                }
            }
        })
    })
});

const updateTransitionMutation = gql`
mutation updateTransition($transitionId: ID!, $transitionInput: TransitionUpdateInput!) {
  updateTransition(transitionId: $transitionId, transitionInput: $transitionInput) {
    ...transitionFields
  }
}
${fragments.transitionFields}`;

const updateTransitionMutationHoc = graphql(updateTransitionMutation, {
    props: ({mutate}) => ({
        updateTransition: (transitionId, transitionInput) => mutate({
            variables: {transitionId, transitionInput}
        })
    })
});

const deleteTransitionMutation = gql`
mutation deleteTransition($transitionId: ID!) {
  deleteTransition(transitionId: $transitionId) {
    ...transitionFields
  }
}
${fragments.transitionFields}`;

const deleteTransitionMutationHoc = graphql(deleteTransitionMutation, {
    props: ({mutate}) => ({
        deleteTransition: (transitionId) => mutate({
            variables: {transitionId},
            updateQueries: {
                project: (prev) => {
                    let index = prev.project.transitions.findIndex(transition => transition.id === transitionId);
                    return update(prev, {
                        project: {
                            transitions: {
                                $splice: [[index, 1]]
                            }
                        }
                    });
                }
            }
        })
    })
});

const createTransitionEventMutation = gql`
mutation createTransitionEventMutation($projectId: ID!, $transitionEventInput: TransitionEventInput!) {
  createTransitionEvent(projectId: $projectId, transitionEventInput: $transitionEventInput) {
    ...transitionEventFields
  }
}
${fragments.transitionEventFields}`;

const createTransitionEventMutationHoc = graphql(createTransitionEventMutation, {
    props: ({mutate}) => ({
        createTransitionEvent: (projectId, transitionEventInput) => mutate({
            variables: {projectId, transitionEventInput},
            updateQueries: {
                project: (prev, {mutationResult}) => {
                    if (mutationResult.errors) {
                        return prev;
                    }
                    const newTransitionEvent = mutationResult.data.createTransitionEvent;
                    return update(prev, {
                        project: {
                            transitionEvents: {
                                $push: [newTransitionEvent]
                            }
                        }
                    });
                }
            }
        })
    })
});

const updateTransitionEventMutation = gql`
mutation updateTransitionEventMutation($transitionEventId: ID!, $transitionEventInput: TransitionEventInput!) {
  updateTransitionEvent(transitionEventId: $transitionEventId, transitionEventInput: $transitionEventInput) {
    ...transitionEventFields
  }
}
${fragments.transitionEventFields}`;

const updateTransitionEventMutationHoc = graphql(updateTransitionEventMutation, {
    props: ({mutate}) => ({
        updateTransitionEvent: (transitionEventId, transitionEventInput) => mutate({
            variables: {transitionEventId, transitionEventInput}
        })
    })
});

const deleteTransitionEventMutation = gql`
mutation deleteTransitionEventMutation($transitionEventId: ID!) {
  deleteTransitionEvent(transitionEventId: $transitionEventId) {
    ...transitionEventFields
  }
}
${fragments.transitionEventFields}`;

const deleteTransitionEventMutationHoc = graphql(deleteTransitionEventMutation, {
    props: ({mutate}) => ({
        deleteTransitionEvent: (transitionEventId) => mutate({
            variables: {transitionEventId},
            updateQueries: {
                project: (prev) => {
                    let index = prev.project.transitionEvents.findIndex(event => event.id === transitionEventId);
                    return update(prev, {
                        project: {
                            transitionEvents: {
                                $splice: [[index, 1]]
                            }
                        }
                    });
                }
            }
        })
    })
});

const createActionMutation = gql`
mutation createActionMutation($projectId: ID!, $actionInput: ActionInput!) {
    createAction(projectId: $projectId, actionInput: $actionInput) {
        ...actionFields
    }
}
${fragments.actionFields}`;

const createActionMutationHoc = graphql(createActionMutation, {
    props: ({mutate}) => ({
        createAction: (projectId, actionInput) => mutate({
            variables: {projectId, actionInput},
            updateQueries: {
                project: (prev, {mutationResult}) => {
                    if (mutationResult.errors) {
                        return prev;
                    }
                    const newAction = mutationResult.data.createAction;
                    return update(prev, {
                        project: {
                            actions: {
                                $push: [newAction]
                            }
                        }
                    });
                }
            }
        })
    })
});

const updateActionMutation = gql`
mutation updateActionMutation($actionId: ID!, $actionInput: ActionInput!) {
    updateAction(actionId: $actionId, actionInput: $actionInput) {
        ...actionFields
    }
}
${fragments.actionFields}`;

const updateActionMutationHoc = graphql(updateActionMutation, {
    props: ({mutate}) => ({
        updateAction: (actionId, actionInput) => mutate({
            variables: {actionId, actionInput}
        })
    })
});

const deleteActionMutation = gql`
mutation deleteActionMutation($actionId: ID!) {
    deleteAction(actionId: $actionId) {
        ...actionFields
    }
}
${fragments.actionFields}`;

const deleteActionMutationHoc = graphql(deleteActionMutation, {
    props: ({mutate}) => ({
        deleteAction: (actionId) => mutate({
            variables: {actionId},
            updateQueries: {
                project: (prev) => {
                    let index = prev.project.actions.findIndex(action => action.id === actionId);
                    return update(prev, {
                        project: {
                            actions: {
                                $splice: [[index, 1]]
                            }
                        }
                    });
                }
            }
        })
    })
});

export default {
    // Flows
    createFlowMutation,
    createFlowMutationHoc,
    updateFlowMutation,
    updateFlowMutationHoc,
    deleteFlowMutation,
    deleteFlowMutationHoc,

    // States
    createNullStateMutation,
    createNullStateMutationHoc,
    createFromAnyStateMutation,
    createFromAnyStateMutationHoc,
    createStateMutation,
    createStateMutationHoc,
    updateStateMutation,
    updateStateMutationHoc,
    deleteStateMutation,
    deleteStateMutationHoc,

    // Transitions
    createTransitionMutation,
    createTransitionMutationHoc,
    updateTransitionMutation,
    updateTransitionMutationHoc,
    deleteTransitionMutation,
    deleteTransitionMutationHoc,

    // TransitionEvents
    createTransitionEventMutation,
    createTransitionEventMutationHoc,
    updateTransitionEventMutation,
    updateTransitionEventMutationHoc,
    deleteTransitionEventMutation,
    deleteTransitionEventMutationHoc,

    // Actions
    createActionMutation,
    createActionMutationHoc,
    updateActionMutation,
    updateActionMutationHoc,
    deleteActionMutation,
    deleteActionMutationHoc,
};



// WEBPACK FOOTER //
// ./src/graphql/mutationsWorkflow.js